import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';

export interface UnsavedChangesComponent {
  hasUnsavedChanges(): boolean;
}

export const unsavedChangesGuard: CanDeactivateFn<UnsavedChangesComponent> = (component, currentRoute, currentState, nextState) => {
  // If component doesn't implement the interface, allow navigation
  if (!component || typeof component.hasUnsavedChanges !== 'function') {
    return true;
  }

  // Check if there are unsaved changes
  if (component.hasUnsavedChanges()) {
    // Show confirmation dialog
    return confirm('You have unsaved changes. Are you sure you want to leave?');
  }

  return true;
}; 